const optionsPages = [
  { value: 10, label: 'Ver 10 resultados por página' },
  { value: 20, label: 'Ver 20 resultados por página' },
  { value: 50, label: 'Ver 50 resultados por página' },
  { value: 100, label: 'Ver 100 resultados por página' }
];

export default { optionsPages }